import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import { CardtronicsCustomers } from "./types";
import {
  ADD_UPDATE_CARDTRONICS_CUSTOMER_REQUEST,
  FETCH_CARDTRONICS_CUSTOMER_LIST_REQUEST,
} from "./actionTypes";
import {
  addUpdateCardtronicsCustomerFailure,
  addUpdateCardtronicsCustomerSuccess,
  fetchCardtronicsCustomerListFailure,
  fetchCardtronicsCustomerListSuccess,
} from "./actions";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchCardtronicsCustomerListSaga(action: any) {
  try {
    const response: CardtronicsCustomers[] = yield call(
      postRequest,
      action.url,
      action.payload,
    );

    const totalCount =
      response && response.length > 0 && response[0]?.totalCount
        ? response[0].totalCount
        : 0;
    yield put(fetchCardtronicsCustomerListSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchCardtronicsCustomerListFailure(errorMessage));
  }
}

function* addUpdateCardtronicsCustomerSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload,
    );
    yield put(addUpdateCardtronicsCustomerSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateCardtronicsCustomerFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* cardtronicsSaga() {
  yield takeLatest(
    FETCH_CARDTRONICS_CUSTOMER_LIST_REQUEST,
    fetchCardtronicsCustomerListSaga,
  );
  yield takeLatest(
    ADD_UPDATE_CARDTRONICS_CUSTOMER_REQUEST,
    addUpdateCardtronicsCustomerSaga,
  );
}
